import React, {Component} from "react";
import ProductTable from "../../customers/shared/ProductTable";
import TaskIcon from "../shared/TaskIcon";
import "./Products.css";

class Products extends Component {

  render() {
    let {products, subscriptionName, subscriptionFrequencyWeeks} = this.props;

    return (
      <div className="Products section">
        <TaskIcon nr="4" completed={true} />
        <div className="title">Review Order</div>
        <div className="content">
          <ProductTable
            products={products}
            subscriptionName={subscriptionName}
            subscriptionFrequencyWeeks={subscriptionFrequencyWeeks}
            showSubtotal={false}
            />       
        </div>
      </div>
    )
  }

}

export default Products;